export { abbreviateSpeciesName, abbreviateTimberDrynessDisplay } from './timberDisplayLabels';

/** Supplier name → initials (matches timber list Sup column). */
export function supplierInitialsFromName(supplier?: string | null): string {
  const name = (supplier || '').trim();
  if (!name) return '';
  return name
    .split(/[\s&,]+/)
    .filter(Boolean)
    .map(w => w[0]!.toUpperCase())
    .join('');
}
